<template>
  <div id="register">
    <!--<div class="ibg-bg" style="transform: matrix(1, 0, 0, 1, 0, 0); transition: all 500ms linear 0s;"></div>-->
    <div class="register-header">
      <div class="logo" style="margin: 15px;">
        <img style="width: 225px;" src="static/img/gc-logo.png">
      </div>
      <span class="logo" style="width: 100px;margin: 19px;">注册吉凯账号</span>
    </div>
    <div class="ibg-bg">
      <div class="register-container" content="center">
        <div class="con-box" content="center">
          <!--<div style="margin-top: 40px;">-->
          <!--<span>注册吉凯账号</span>-->
          <!--</div>-->
          <div class="register-form">
            <el-form status-icon ref="ruleForm" class="demo-ruleForm" size="medium" style="padding: 30px;">
              <el-form-item prop="userName">
                <el-input type="text" v-model="userName" placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item prop="account">
                <el-input type="text" v-model="account" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item>
              <el-input type="text" v-model="email" placeholder="邮箱"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="password" v-model="password" placeholder="登录密码"></el-input>
              </el-form-item>
              <el-form-item prop="rePassword">
                <el-input type="password" v-model="rePassword" placeholder="确认密码"></el-input>
              </el-form-item>
              <div id="select">
                <el-form-item>
                  <el-select v-model="enterpriseComputed" filterable remote placeholder="请输入单位"
                             :remote-method="remoteMethod"
                             :loading="loading"
                             class="form-width"
                             clearable
                             id="select-enterprise">
                    <el-option
                      v-for="item in enterpriseList"
                      :key="item.value"
                      :label="item.enterpriseName"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!--<el-form-item>-->
              <!--<el-input type="text" v-model="userName" placeholder="地址（可选）"></el-input>-->
              <!--</el-form-item>-->
              <el-form-item>
                <div style="display: flex; flex-direction: row">
                  <el-input type="text" v-model="code" placeholder="验证码" style="margin-right: 12px;"></el-input>
                  <el-button type="primary" @click="register" :loading="coolDown" :disabled="disabledSend">{{sendCodeText}}</el-button>
                </div>
              </el-form-item>
              <el-form-item class="submit-btn">
                <el-button type="primary" @click="submit" style="width: 100%;" :disabled="disableSubmit">提交</el-button>
                <el-button type="text" @click="returnLogin" style="float: left;">返回登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="register-foot foot">
        <foot></foot>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import ct from '../../utils/constant.js'
import { getStorage, setStorage, sendVerCode } from '../../utils/utils.js'
import foot from '../../components/Footer.vue'
export default {
  created () {
  },
  mounted () {
  },
  components: {
    foot
  },
  data () {
    return {
      loading: false,
      enterpriseList: [],
      userName: '',
      account: '',
      password: '',
      rePassword: '',
      enterprise: '',
      code: '',
      disableSubmit: true,
      coolDown: false,
      sendVeriCodeSuccess: false,
      sendCodeText: '发送',
      enterpriseName: '',
      email: ''
    }
  },
  watch: {
    'code': function (val) {
      let reg = new RegExp(/^\d{6}$/)
      if (this.sendVeriCodeSuccess || reg.test(val)) {
        this.disableSubmit = false
      } else {
        this.disableSubmit = true
      }
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      this.enterpriseList = []
      let list = getStorage('enterpriseList')
      for (let i = 0; i < list.length; i++) {
        let l = list[i]
        let obj = {}
        // console.log(query)
        if (l.enterpriseName.match(query.toLowerCase())) {
          obj.enterpriseName = l.enterpriseName
          obj.enterpriseNo = l.enterpriseNo
          obj.locationName = l.locationName
          obj.regionName = l.regionName
          this.enterpriseList.push(obj)
        }
        if (l.enterpriseName === query.toLowerCase()) {
          this.enterpriseList.unshift(obj)
        }
        if (this.enterpriseList.length > 200) {
          break
        }
      }
      this.loading = false
    },
    sendVeriCode () {
      let phone = this.account.replace(/\s+/g, '')
      if (!this.phoneVeri(phone)) {
        this.$message({message: '请输入11位正确格式的手机号码！', type: 'error'})
        return
      }
      sendVerCode(this, ct.SendVeriCodeType.register)
    },
    checkInfo () {
      if (this.email) {
        if (!/^\w+([._-]\w+)*@(\w+\.)+\w+$/.test(this.email)) {
          this.$message({message: '请输入正确格式的邮箱地址！', type: 'error'})
          return false
        }
      }
      return true
    },
    register () {
      let phone = this.account.replace(/\s+/g, '')
      if (!this.phoneVeri(phone)) {
        this.$message({message: '请输入11位正确格式的手机号码！', type: 'error'})
        return
      }
      if (this.password !== this.rePassword) {
        this.$message({message: '两次输入的密码不一致！', type: 'error'})
        return
      }
      if (this.checkInfo()) {
        let address = ''
        // let address = this.Address
        // address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '')
        this.postRequest('gcwwwifc/addCloudCustomer', {
          'CustomerName': this.userName.replace(/\s/g, ''),
          'Mobile': phone,
          'Password': md5(this.password).toUpperCase(),
          'EnterpriseNo': this.enterprise.enterpriseNo,
          'Email': this.email,
          'Address': address,
          'AddEnterprise': this.enterprise.enterpriseName,
          'ReceivePromotion': 1,
          'Source': '吉凯云'
        }).then((response) => {
          if (response.data.code === 0) {
            this.sendVeriCode()
          } else {
            // console.log(response)
            this.$message({message: response.data.message, type: 'error'})
          }
        })
      } else {
        // $.toast(this.error)
      }
    },
    submit () {
      this.postRequest('gcwwwifc/activateCustomer', {'LoginId': this.account.replace(/\s+/g, ''), 'VerifyCode': this.code})
        .then((response) => {
          if (response.data.code === 0) {
            this.login()
          } else {
          }
        })
    },
    login () {
      if (this.account && this.password) {
        this.postRequest('gcwwwifc/login', {
          'LoginId': this.account.replace(/\s+/g, ''),
          'Password': md5(this.password).toUpperCase()
        }).then((response) => {
          if (response) {
            this.$router.push(ct.RouterData.netDisk.path)
            setStorage('user', response.data.result)
            window.getHomeData()
          }
        })
      } else {
        // $.toast('请输入登录信息')
      }
    },
    returnLogin () {
      this.$router.push(ct.RouterData.login.path)
    }
  },
  computed: {
    disabledSend () {
      return !this.account || this.account === '' || this.userName === '' ||
          this.rePassword === '' || this.enterprise === '' || this.password === ''
    },
    enterpriseComputed: {
      get: function () {
        return this.enterpriseName
      },
      set: function (val) {
        this.enterpriseName = val.enterpriseName
        this.enterprise = val
      }
    }
  }
}
</script>
<style>
  .foot {
    margin-top: 80px;
  }

  #select-enterprise .el-input .el-input--medium .el-input--suffix .is-focus {
    width:100%;
  }

  #select .el-select .el-input {
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/Register.vue